export default "__VITE_ASSET__D7gFR8Vy__"